<app-container type="dark" title="Details">
	<div class="flex flex-1 flex-col">
		<ng-container
			*ngIf="
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
			"
		>
			<div class="flex justify-between items-start mb-3">
				<div>Additional consideration</div>
				<div>+ {{ adjustment.considerations | centsToDollars }}</div>
			</div>
			<div class="flex justify-between items-start mb-3">
				<div>Credits to purchaser</div>
				<div>- {{ adjustment.credits | centsToDollars }}</div>
			</div>
			<div class="flex justify-end items-start mb-3">
				<div>
					<strong>Total = {{ total | centsToDollars }}</strong>
				</div>
			</div>
		</ng-container>
		<div class="flex justify-between items-start mb-3">
			<div>Sale price as per agreement</div>
			<div>{{ purchasePrice | centsToDollars }}</div>
		</div>
		<div
			*ngIf="
				adjustment.netOutHst !== 'no' &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
			"
		>
			<div class="flex justify-between items-start mb-3">
				<div>HST Federal portion (5%)</div>
				<div>- {{ hstFed | centsToDollars }}</div>
			</div>
			<div class="flex justify-between items-start mb-3">
				<div>HST Ontario portion (8%)</div>
				<div>- {{ hstProv | centsToDollars }}</div>
			</div>
		</div>
		<div *ngIf="adjustment.netOutHst === netOutHstOptions.YES_HST">
			<div class="flex justify-between items-start mb-3">
				<div>HST rebate, Federal portion</div>
				<div>+ {{ hstRebateFed | centsToDollars }}</div>
			</div>
			<div class="flex justify-between items-start mb-3">
				<div>HST rebate, Ontario portion</div>
				<div>+ {{ hstRebateProv | centsToDollars }}</div>
			</div>
		</div>
		<div
			*ngIf="
				adjustment.netOutHst !== netOutHstOptions.NO &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
			"
			class="flex justify-end items-start mb-3"
		>
			<div>
				<strong>Net sale price = {{ nsp | centsToDollars }}</strong>
			</div>
		</div>

		<ng-container
			*ngIf="
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST &&
				adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
			"
		>
			<div class="flex justify-between items-start mb-3">
				<div>Real estate portion of NSP</div>
				<div>+ {{ nspReal | centsToDollars }}</div>
			</div>
			<div class="flex justify-between items-start mb-3">
				<div>Chattels portion of NSP</div>
				<div>+ {{ adjustment.chattels | centsToDollars }}</div>
			</div>
		</ng-container>

		<div class="flex justify-end items-start mb-3">
			<div>
				<strong>Credit vendor = {{ creditAmount | centsToDollars }}</strong>
			</div>
		</div>
	</div>
</app-container>
